import Bookmark from './model.js';
import Bookmarks from './collection.js';
import './plugin.js';

export { Bookmark, Bookmarks };
